/**
 * Return a content ID for an organization.
 */
export function getOrganizationRootContentId(organizationId: string): string {
    return `org:${organizationId}`;
}

/**
 * Check if a content ID is an organization root content ID, and return the organization ID if so.
 */
export function getOrganizationIdFromContentId(contentId: string): string | null {
    const match = contentId.match(/^org:(.+)$/);
    if (!match) {
        return null;
    }
    return match[1];
}
